export default "__VITE_ASSET__Cp37oFJ6__"